import { useState } from 'react';
import { Fund, useGetFunds } from '../../api/useFunds';
import { cacheToMap } from '../cashbackCalculatorUtil';

export const useInitialState = (defaultState?: Record<string, number>) => {
  const isins = defaultState ? Object.keys(defaultState) : undefined;
  const [initialState, setInitialState] = useState<Map<Fund, number> | undefined>(
    defaultState ? undefined : cacheToMap()
  );

  const result = useGetFunds(isins, {
    onSuccess: (data) => {
      const defaultStateMap = new Map<Fund, number>();
      if (defaultState) {
        data?.funds?.forEach((f) => {
          const value = defaultState[f.isin || ''];
          defaultStateMap.set(f, value);
        });
      }
      setInitialState(defaultStateMap);
    },
    enabled: !initialState && isins && isins.length > 0,
  });

  return { ...result, data: initialState };
};
